import React from "react";
import Navbar from "../components/Navbar";
import SecondaryHero from "../components/SecondaryHero";
import ServicesSolution from "../components/ServicesSolution";
import { ServicesOfGraphic } from "../components/Data/ServiceData";
import Servicesbuttom from "../components/Servicesbuttom";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const GraphicServic = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Graphic Designing Services | VisionBird Technologies</title>
        <meta
          name="description"
          content="VisionBird Technologies provides professional graphic design services including logo design, branding, print design, advertising, and digital graphics."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        title="GRAPHIC "
        highlight="DESIGNING"
        description="VisionBird Technologiesis providing print graphics, web graphics, 
logo design, offset printing, digital printing, image development, 
advertising, marketing, promotions, illustration, web development, 
and print production."
        image="/assets/Images/Website designer-pana 1 (1).png"
      />
      <ServicesSolution
        title="BEST"
        highlight=" GRAPHIC DESIGN"
        afterthat=" SERVICES"
        description="VisionBird Technologies is a full-service design and print production company that offers a wide range of services to meet the needs of its clients."
        servicesData={ServicesOfGraphic}
      />
      <Servicesbuttom
        teamImages={[
          "/assets/Images/nomann.jpg",
          "/assets/Images/naveed.jpeg",
          "/assets/Images/AdilRaja.png",
        ]}
      />
      <Footer />
    </>
  );
};

export default GraphicServic;